import React, { useContext, useState } from 'react';

const GoogleAnalyticsErrorContext = React.createContext({
  gaError: '',
  setGaError: (code: number) => {}
});

export function GoogleAnalyticsErrorProvider ({ children }: { children?: React.ReactNode }) {
  const [error, setError] = useState('');
  function setGaError (code: number) {
    switch (code) {
      case 401:
        return setError('invalidGrant');
      case 403:
        return setError('quotaError');
      default:
        return setError('unknownError');
    }
  }
  return (
    <GoogleAnalyticsErrorContext.Provider value={{ gaError: error, setGaError }}>
      {children}
    </GoogleAnalyticsErrorContext.Provider>
  );
}

export const useGoogleAnalyticsErrorContext = () => useContext(GoogleAnalyticsErrorContext);

export default GoogleAnalyticsErrorContext;
